import styled from '@emotion/styled';

export const StyledDateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
